import { Box, Button, Typography } from '@mui/material'
import { Center } from 'components/Center'
import { Link } from 'react-router-dom'

export default function HomePage() {
  return (
    <Center>
      <Typography variant="h1" sx={{fontSize: '4rem'}}>MagiCAD Access Management</Typography>
      <Typography variant="h2" sx={{fontSize: '2.5rem'}}>Landing/marketing page</Typography>
      <Box m={4}>
        <Button color="plain" variant="contained" component={Link} to="/accounts">Login to access</Button>
      </Box>
    </Center>
  )
}